import { Inject, Injectable } from '@angular/core';
import { ENV, IEnvironment } from 'env/config';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { DataService } from '../http/dataService';
import { CentralApis } from '../interfaces/internal';
import { IAddressSmbExtension } from '../models/address-smb.model';
import { Repository } from './repository';

@Injectable({ providedIn: 'root' })
export class AddressSmbService extends Repository<IAddressSmbExtension> {
  constructor(@Inject(ENV) env: IEnvironment, dataService: DataService) {
    super({
      client: dataService,
      url: (env.api.backend.central.endpoint as CentralApis).activity,
    });
    this.api = 'address_smb/batch_smb';
  }

  batchSmb(addressIds: string[]): Observable<IAddressSmbExtension[]> {
    return this.post<IAddressSmbExtension[]>(addressIds).pipe(
      map((result) => result ?? []),
      catchError(() => of([]))
    );
  }

  createFromDTO(item): IAddressSmbExtension {
    return item;
  }
}
